import { useEffect } from "react";
import { useTypingAnimation } from "./useTypingAnimation";

interface TypingAnimationProps {
  text: string;
  speed?: number;
  isActive: boolean;
  className?: string;
  onComplete?: () => void;
}

/**
 * TypingAnimation component that animates the text as it is typed.
 *
 * Usage:
 * <TypingAnimation text="Hello, world!" isActive={true} />
 */
export default function TypingAnimation({
  text,
  speed = 50,
  isActive,
  className = "",
  onComplete,
}: TypingAnimationProps) {
  const { displayText, isTyping } = useTypingAnimation(
    isActive ? text : text,
    speed
  );

  useEffect(() => {
    if (!isTyping && displayText && onComplete) {
      onComplete();
    }
  }, [isTyping, displayText, onComplete]);

  // Return the final text if not active, otherwise return animated text
  const finalText = isActive ? displayText : text;

  return <span className={className}>{finalText}</span>;
}
